import { Component, Suspense } from 'react';

// project imports
import Loader from './Loader';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const CHUNK_RELOAD_GUARD_KEY = 'chunk-reload-once';

function isChunkLoadError(error) {
  const message = String(error?.message || error || '').toLowerCase();
  return (
    message.includes('failed to fetch dynamically imported module') ||
    message.includes('importing a module script failed') ||
    message.includes('loading chunk') ||
    message.includes('chunkloaderror')
  );
}

class ChunkErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error) {
    if (typeof window === 'undefined') return;
    if (!isChunkLoadError(error)) return;

    const alreadyReloaded = sessionStorage.getItem(CHUNK_RELOAD_GUARD_KEY) === '1';
    if (!alreadyReloaded) {
      sessionStorage.setItem(CHUNK_RELOAD_GUARD_KEY, '1');
      window.location.reload();
      return;
    }
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  handleReload = () => {
    if (typeof window === 'undefined') return;
    sessionStorage.removeItem(CHUNK_RELOAD_GUARD_KEY);
    window.location.reload();
  };

  render() {
    const { error } = this.state;
    const { children } = this.props;

    if (!error) return children;

    return (
      <div style={{ padding: 24 }}>
        <h3 style={{ marginTop: 0 }}>Something went wrong while loading this page.</h3>
        <p style={{ marginBottom: 16 }}>
          Please refresh once. If this continues, clear browser cache and try again.
        </p>
        <button type="button" onClick={this.handleReload} style={{ cursor: 'pointer' }}>
          Reload
        </button>
      </div>
    );
  }
}

const Loadable = (LazyComponent) => (props) => (
  <ChunkErrorBoundary>
    <Suspense fallback={<Loader />}>
      <LazyComponent {...props} />
    </Suspense>
  </ChunkErrorBoundary>
);

export default Loadable;
